// import { setLayerSelected, setLayerUnselected } from 'drawer/tabs/layers/actions'

import get from 'lodash/get'
import isBoolean from 'lodash/isBoolean'
import isNil from 'lodash/isNil'
import memoize from 'lodash/memoize'

import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'

/**
 * @desc
 * Adapter registers events.
 *
 * Consume using Pozi Model. E.g. Model.on('app.event...', someFunction)
 *
 * @fires app.event.layer.visible (layer): When a layer becomes visible.
 * @fires app.event.layer.invisible (layer): When a layer becomes invisible.
 */

const PoziEvents = memoize(function () {
  // Adapters
  const adapters = {
    onLayerVisible: function (olLayer, bVisible) {
      return onLayerVisible(olLayer, bVisible)
    }
  }

  const onLayerVisible = function (olLayer, bVisible = undefined) {
    // console.debug('onLayerVisible', olLayer.get('titleid'), bVisible, olLayer)

    if (isNil(olLayer)) {
      console.error('Invalid olLayer object.')
      return
    }

    const titleid = olLayer.get('titleid')
    const layerConf = PoziUtils.getLayerFromOLLayer(olLayer)

    if (!layerConf) {
      console.log('onLayerVisible - layer config not found', titleid)
    }

    // Only set visible/invisible if provided as an arguments
    if (typeof bVisible === 'boolean') {
      if (bVisible) {
        Model.set('app.event.layer.visible', layerConf)
      } else {
        Model.set('app.event.layer.invisible', layerConf)
      }
    }

    olLayer.on('change:visible', function (olObjectEvent) {
      if (isNil(olObjectEvent)) {
        console.error('Invalid event object.')
        return
      }
      const key = get(olObjectEvent, 'key', null)
      if (isNil(key)) {
        console.error('Unable to get event key.')
        return
      }
      const oldValue = get(olObjectEvent, 'oldValue', null)
      if (isNil(oldValue)) {
        console.error('Unable to get event value.')
        return
      }
      const layer = PoziUtils.getLayerFromOLLayer(get(olObjectEvent, 'target', null))
      if (isNil(layer)) {
        console.error('Unable to get layer.')
        return
      }
      if (key === 'visible') {
        if (!isBoolean(oldValue)) {
          console.error('Unable to get old value.')
          return
        }
        const bVisible = !oldValue
        if (bVisible) {
          Model.set('app.event.layer.visible', layer)
          layer.selected = true
          // window.store.dispatch(setLayerSelected(titleid))
          // window.store.dispatch(setLayerVisible(titleid))
        } else {
          Model.set('app.event.layer.invisible', layer)
          layer.selected = false
          // window.store.dispatch(setLayerUnselected(titleid))
          // window.store.dispatch(setLayerHidden(titleid))
        }
      }

      HistoryUpdate()
    })
  }

  return adapters // Return adapters (must be at end of adapter)
})

export default PoziEvents
// End A (Adapter)
